export default __webpack_public_path__ + "static/img/img_gxjsqy.9735a89.png";